import React, { useState, useRef, useEffect } from 'react';

/**
 * Inline editable cell. Click to edit, blur/Enter to save.
 * Props: value, onSave(newValue), type ('number'|'text'), className
 */
const InlineEditCell = ({ value, onSave, type = 'number', className = '' }) => {
  const [editing, setEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => { setEditValue(value); }, [value]);
  useEffect(() => { if (editing && inputRef.current) inputRef.current.select(); }, [editing]);

  const save = () => {
    setEditing(false);
    const newVal = type === 'number' ? (parseFloat(editValue) || 0) : editValue;
    if (newVal !== value) onSave(newVal);
  };

  if (editing) {
    return (
      <input
        ref={inputRef}
        type={type}
        value={editValue}
        onChange={e => setEditValue(e.target.value)}
        onBlur={save}
        onKeyDown={e => { if (e.key === 'Enter') save(); if (e.key === 'Escape') { setEditValue(value); setEditing(false); } }}
        className={`h-7 w-full text-center text-sm font-medium border-2 border-blue-400 rounded bg-blue-50 focus:outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ${className}`}
        data-testid="inline-edit-input"
      />
    );
  }

  return (
    <span
      className={`cursor-pointer hover:bg-blue-50 hover:text-blue-700 rounded px-1 py-0.5 transition-colors ${className}`}
      onClick={() => setEditing(true)}
      title="Click to edit"
      data-testid="inline-edit-value"
    >
      {value || '—'}
    </span>
  );
};

export default InlineEditCell;
